import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from "react-dom";
import TaskCreated from './item-created/task-created/task-created';
import EventCreated from "./item-created/event-created/event-created";
import ReminderCreated from "./item-created/reminder-created/reminder-created";
import ClientCreated from "./item-created/client-created/client-created";
import ChatMessage from "./misc/chat-message/chat-message";
import GrowlRateExperience from "./misc/rate-experience/rate-experience";
import CustomerCreated from "./item-created/customer-created/customer-created";
import AutomationCreated from "./item-created/automation-created/automation-created";
import AutomationApplied from "./misc/automation-applied/automation-applied";
import ErrorMessage from "./system/error-message/error-message";
import WarningMessage from "./system/warning-message/warning-message";
import ConnectionError from "./misc/connection-error/connection-error";
import InfoMessage from "./system/info-message/info-message";
import {GrowlType} from "../@types";
import Growl_SuccessMessage from "./system/success/success";

type Props = {
    data       : any
    fadeTime   : number
    visibleTime: number
}

export default class InfoNotification extends React.Component<Props> {

    static propTypes = {
        data: PropTypes.object.isRequired,
        fadeTime: PropTypes.number,
        visibleTime: PropTypes.number
    };

    static defaultProps = {
        fadeTime        : 1.0,
        visibleTime     : 5
    };

    public timer : any

    constructor(props: Props) {
        super(props);
    }

    componentDidMount() {
        this.onShow();
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    onShow = () => {
        if (this.timer) clearTimeout(this.timer);

        this.toggleVisibleClass("fade-in");

        if (this.props.data.selfDestroy) {
            this.timer = setTimeout(this.onClose, this.props.visibleTime * 1000); // Self destroy 1000
        }
    };

    onClose = () => {
        if (this.timer) clearTimeout(this.timer);

        this.toggleVisibleClass("fade-out");
        this.timer = setTimeout(this.removeSelfNotification, this.props.fadeTime * 1000);
    };

    removeSelfNotification = () => {
        if (this.timer) clearTimeout(this.timer);
        gd.growl.removeNotification(this.props.data);
    };

    toggleVisibleClass = (className: string) => {
        const el: any = findDOMNode(this);
        el.classList.remove("fade-in", "fade-out");
        el.classList.add(className);
    };

    render() {

        switch (this.props.data.type) {
            case GrowlType.CHAT_MESSAGE:
                return (
                    <ChatMessage chatId={this.props.data.message.chatId}
                                 fromUserId={this.props.data.message.fromUserId}
                                 message={this.props.data.message.message}
                                 close={this.removeSelfNotification}
                                 fadeTime={this.props.fadeTime}/>
                );

            case GrowlType.EVENT_CREATED:
                return (
                    <EventCreated id={this.props.data.message.id}
                                  title={this.props.data.message.title}
                                  close={this.removeSelfNotification}
                                  fadeTime={this.props.fadeTime}/>
                );

            case GrowlType.TASK_CREATED:
                return (
                    <TaskCreated id={this.props.data.message.id}
                                 shortId={this.props.data.message.shortId}
                                 title={this.props.data.message.title}
                                 close={this.removeSelfNotification}
                                 fadeTime={this.props.fadeTime}/>
                );

            case GrowlType.AUTOMATION_APPLIED:

                return (
                    <AutomationApplied automationId={this.props.data.message.id}
                                       close={this.removeSelfNotification}
                                       fadeTime={this.props.fadeTime}/>
                )

            case GrowlType.AUTOMATION_CREATED:
                return (
                    <AutomationCreated id={this.props.data.message.id}
                                       close={this.removeSelfNotification}
                                       fadeTime={this.props.fadeTime}/>
                );

            case GrowlType.RATE_EXPERIENCE:
                return <GrowlRateExperience close={this.removeSelfNotification} {...this.props} />;

            case GrowlType.REMINDER_CREATED:
                return (
                    <ReminderCreated id={this.props.data.message.id}
                                     title={this.props.data.message.title}
                                     close={this.removeSelfNotification}
                                     fadeTime={this.props.fadeTime}/>
                );

            case GrowlType.CLIENT_CREATED:
                return (
                    <ClientCreated id={this.props.data.message.id}
                                   title={this.props.data.message.title}
                                   type={this.props.data.message.type}
                                   close={this.removeSelfNotification}
                                   fadeTime={this.props.fadeTime}/>
                );

            case GrowlType.CUSTOMER_CREATED:
                return (
                    <CustomerCreated id={this.props.data.message.id}
                                     title={this.props.data.message.title}
                                     close={this.removeSelfNotification}
                                     fadeTime={this.props.fadeTime}/>
                );

            case GrowlType.SUCCESS:
                return (
                    <Growl_SuccessMessage message={this.props.data.message}
                                    close={this.removeSelfNotification}
                                    fadeTime={this.props.fadeTime}/>
                );

            case GrowlType.WARNING:
                return (
                    <WarningMessage message={this.props.data.message}
                                    close={this.removeSelfNotification}
                                    fadeTime={this.props.fadeTime}/>
                );
            case GrowlType.CONNECTION_ERROR:
                return (
                    <ConnectionError message={this.props.data.message}
                                     close={this.removeSelfNotification}
                                     fadeTime={this.props.fadeTime}/>
                );

            case GrowlType.ERROR:
                return (
                    <ErrorMessage message={this.props.data.message}
                                  close={this.removeSelfNotification}
                                  fadeTime={this.props.fadeTime}/>
                );
            default:
                return (
                    <InfoMessage message={this.props.data.message}
                                 close={this.removeSelfNotification}
                                 fadeTime={this.props.fadeTime}/>
                );
        }
    }
}
